import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import ReactTableTextFilter from '../../../components/ReactTableTextFilter';
import ReactTableSelectFilter from "../../../components/ReactTableSelectFilter";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import ScoreBoardDetails from "../../../containers/ScoreBoardDetails";
import ModalManager from "../../../components/modal/ModalManager";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import LoaderButton from "../../../components/LoaderButton";
import {reactTableText} from '../../../constants/configs';
import UserInfo from "../../../components/UserInfo";
import {i18nizeDate} from '../../../helpers/Utils';
import {keyBy, mapValues, omit} from "lodash";
import {withTranslation} from 'react-i18next';
import Rbac from "../../../components/Rbac";
import Api from "../../../services/Api";
import ReactTable from 'react-table';
import Switch from "react-switch";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      campaigns: [],
      pages: -1,
      loading: false,
      expanded: {},
    };
    this.renderSwitchCell = this.renderSwitchCell.bind(this);
    this.renderStatusFilter = this.renderStatusFilter.bind(this);
    this.renderVisibilityFilter = this.renderVisibilityFilter.bind(this);
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/v2/admin-ui/boards',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
          }
        });
      this.setState({
        campaigns: data.rows,
        pages: Math.ceil(data.count / state.pageSize),
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressStop = (id, name, values) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Stop'),
      body: t('Are you sure you want to stop {{name}} campaign ?', {
        name,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.updateBoard(id, values);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  onPressRestart = (id, name, values) => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Re-start'),
      body: t('Are you sure you want to restart {{name}} campaign ?', {
        name,
      }),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            await this.updateBoard(id, values);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  updateBoard = async (id, values) => {
    try {
      await Api.invoke('PATCH', `/v2/admin-ui/boards/${id}`, values);
      await this.fetchData(this.table.state);
    } catch (e) {
      console.log("error: ", e);
    }
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
      filterable: true,
      Filter: ReactTableTextFilter,
    },
    {
      Header: t('Type'),
      accessor: 'type',
      width: 120,
    },
    {
      Header: t('Status'),
      accessor: 'status',
      filterable: true,
      Filter: this.renderStatusFilter,
      width: 120,
    },
    {
      Header: t('Visibility'),
      accessor: 'visibility',
      filterable: true,
      Filter: this.renderVisibilityFilter,
      Cell: this.renderSwitchCell,
      width: 120,
    },
    {
      Header: t('Creator'),
      accessor: 'creator.value',
      Cell: props => {
        return (
          <UserInfo
            textColor="text-dark"
            label={t('Admin')}
            id={props.value}
            type="ADMIN"
          />
        );
      },
      width: 100,
    },
    {
      Header: t('Start Date'),
      accessor: 'startTime',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "---------"}</span>,
      width: 150,
    },
    {
      Header: t('End Date'),
      accessor: 'endTime',
      Cell: props => <span>{props.value ? i18nizeDate(props.value) : "---------"}</span>,
      width: 150,
    },
    {
      Header: t('Actions'),
      accessor: 'status',
      width: 220,
      Cell: props => <div className="d-flex flex-row align-items-center">
        {props.value !== "STOPPED" && props.value !== "FINISHED" &&
          <Rbac permission='update_boards'>
            <LoaderButton
              outline
              size="sm"
              color="danger"
              onClick={() => {
                this.onPressStop(
                  props.original.id,
                  props.original.name,
                  {status: 'STOPPED'});
              }}
              style={{maxWidth: 110}}
              className="text-center mr-2 flex-1">
              {t('Stop')}
            </LoaderButton>
          </Rbac>
        }
        {props.value === "STOPPED" &&
          <Rbac permission='update_boards'>
            <LoaderButton
              outline
              size="sm"
              color="primary"
              onClick={() => {
                this.onPressRestart(
                  props.original.id,
                  props.original.name,
                  {status: 'STARTED'});
              }}
              style={{maxWidth: 110}}
              className="text-center mr-2 flex-1">
              {t('Re-Start')}
            </LoaderButton>
          </Rbac>
        }
        <Button
          outline
          size="sm"
          color="success"
          onClick={() => {
            this.props.history.push('/dashboard/campaigns/' + props.original.id, {
              endTime: props.original.endTime,
              startTime: props.original.startTime,
            });
          }}
          style={{maxWidth: 110}}
          className="text-center flex-1">
          {t('View Stats')}
        </Button>
      </div>,
    },
  ];

  renderSwitchCell = props => {
    const {value, original} = props;
    return (
      <Switch
        className="mt-2 ltr"
        onChange={async enabled => {
          await this.updateBoard(
            original.id,
            {visibility: enabled}
          );
        }}
        checked={!!value}
        height={24}
        width={45}
      />
    );
  };

  renderVisibilityFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: true, label: t('Active')},
      {value: false, label: t('Inactive')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  renderStatusFilter({filter, onChange}) {
    const {t} = this.props;
    const options = [
      {value: '', label: t('all')},
      {value: 'STARTED', label: t('STARTED')},
      {value: 'STOPPED', label: t('STOPPED')},
      {value: 'FINISHED', label: t('FINISHED')},
    ];
    return <ReactTableSelectFilter
      filter={filter}
      onChange={onChange}
      options={options}
    />;
  }

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  onPressCreate = () => {
    this.props.history.push('/dashboard/campaigns/create');
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-end align-items-center mt-4">
                  <Rbac permission='create_boards'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Create New Campaign')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  ref={el => {this.table = el;}}
                  data={this.state.campaigns}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  expanded={this.state.expanded}
                  defaultPageSize={25}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                  SubComponent={({original}) => <ScoreBoardDetails board={original} updateBoard={this.updateBoard}/>}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
